/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the CodeTableType
 *
 * @class CodeTableType
 */
class CodeTableType {
  /**
   * Creates an instance of CodeTableType.
   * @param {*} json
   * @memberof CodeTableType
   */
  constructor(json = null) {
    if (json) {
      // string
      this.tableName = json.tableName;

      // string
      this.value = json.value;

      // string
      this.description = json.description;

      // string
      this.parentCodeTable = json.parentCodeTable;
    }
  }
}

/**
 * Models the NewACESProviderSearchKey
 *
 * @class NewACESProviderSearchKey
 */
class NewACESProviderSearchKey {
  /**
   * Creates an instance of NewACESProviderSearchKey.
   * @param {*} json
   * @memberof NewACESProviderSearchKey
   */
  constructor(json = null) {
    if (json) {
      // string
      this.providerNameInputString = json.providerNameInputString;

      // object - CodeTableType
      if (json.providerType) {
        this.providerType = new CodeTableType(json.providerType);
      }
    }
  }
}

/**
 * Models the NewACESBurialHomeDetailsResponse
 *
 * @class NewACESBurialHomeDetailsResponse
 */
class NewACESBurialHomeDetailsResponse {
  /**
   * Creates an instance of NewACESBurialHomeDetailsResponse.
   * @param {*} json
   * @memberof NewACESBurialHomeDetailsResponse
   */
  constructor(json = null) {
    if (json) {
      // string
      this.providerId = json.providerId;

      // string
      this.providerName = json.providerName;
    }
  }
}

/**
 * Models the NewACESBurialHomeDetailsListResponse
 *
 * @class NewACESBurialHomeDetailsListResponse
 */
class NewACESBurialHomeDetailsListResponse {
  /**
   * Creates an instance of NewACESBurialHomeDetailsListResponse.
   * @param {*} json
   * @memberof NewACESBurialHomeDetailsListResponse
   */
  constructor(json = null) {
    if (json) {
      // array - NewACESBurialHomeDetailsResponse
      if (json.dtls) {
        this.dtls = json.dtls.map(object => new NewACESBurialHomeDetailsResponse(object));
      } else if (json.constructor === Array) {
        this.dtls = json.map(object => new NewACESBurialHomeDetailsResponse(object));
      }
    }
  }
}

/**
 * Models the NewACESInsuranceProviderDetailsResponse
 *
 * @class NewACESInsuranceProviderDetailsResponse
 */
class NewACESInsuranceProviderDetailsResponse {
  /**
   * Creates an instance of NewACESInsuranceProviderDetailsResponse.
   * @param {*} json
   * @memberof NewACESInsuranceProviderDetailsResponse
   */
  constructor(json = null) {
    if (json) {
      // string
      this.providerId = json.providerId;

      // string
      this.providerName = json.providerName;
    }
  }
}

/**
 * Models the NewACESInsuranceProviderDetailsListResponse
 *
 * @class NewACESInsuranceProviderDetailsListResponse
 */
class NewACESInsuranceProviderDetailsListResponse {
  /**
   * Creates an instance of NewACESInsuranceProviderDetailsListResponse.
   * @param {*} json
   * @memberof NewACESInsuranceProviderDetailsListResponse
   */
  constructor(json = null) {
    if (json) {
      // array - NewACESInsuranceProviderDetailsResponse
      if (json.dtls) {
        this.dtls = json.dtls.map(object => new NewACESInsuranceProviderDetailsResponse(object));
      } else if (json.constructor === Array) {
        this.dtls = json.map(object => new NewACESInsuranceProviderDetailsResponse(object));
      }
    }
  }
}

export default {
  CodeTableType,

  NewACESProviderSearchKey,

  NewACESBurialHomeDetailsResponse,

  NewACESBurialHomeDetailsListResponse,

  NewACESInsuranceProviderDetailsResponse,

  NewACESInsuranceProviderDetailsListResponse,
};
